import { asyncNoop } from 'utils/noop';

export const promptReview = asyncNoop;
